export const animationCreate = () => {
  if (typeof window !== "undefined") {
    // @ts-ignore
    window.WOW = require("wowjs");
  }
  // @ts-ignore
  new WOW.WOW({ live: false }).init();
};
